import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { GridState } from '../../state';
import { InfiniteScrollLoaderBaseProps } from './InfiniteScrollLoaderBaseProps';
import { InfiniteScrollLoaderBase } from './InfiniteScrollLoaderBase';
import { SkeletonGrid } from '../SkeletonGrid';
import { SkeletonTopImageCard } from '../SkeletonGrid/SkeletonTopImageCard';
import { Box } from '@wix/design-system';
import { SkeletonSideImageCard } from '../SkeletonGrid/SkeletonSideImageCard';

export interface SkeletonInfiniteScrollLoaderProps<T, F extends FiltersMap>
  extends InfiniteScrollLoaderBaseProps {
  state: GridState<T, F>;
  imagePlacement?: 'top' | 'side';
}

function _SkeletonInfiniteScrollLoader<T, F extends FiltersMap>({
  state,
  targetRef,
  dataHook,
  imagePlacement,
}: SkeletonInfiniteScrollLoaderProps<T, F>) {
  const { contentPaddingPx } = state.toolbar;

  const renderItem = useCallback(() => {
    return imagePlacement === 'side' ? (
      <SkeletonSideImageCard state={state} />
    ) : (
      <SkeletonTopImageCard state={state} />
    );
  }, [imagePlacement]);

  return (
    <InfiniteScrollLoaderBase state={state.collection} targetRef={targetRef}>
      <Box dataHook={dataHook} paddingBottom={contentPaddingPx}>
        <SkeletonGrid state={state} renderItem={renderItem} />
      </Box>
    </InfiniteScrollLoaderBase>
  );
}

export const SkeletonInfiniteScrollLoader = observer(
  _SkeletonInfiniteScrollLoader,
);
